import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import JourneySection from "./components/JourneySection";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";
import FloatingCTA from "./components/FloatingCTA";

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <FloatingCTA />
      <JourneySection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </main>
  );
}
